export interface NodeAttributes {
  title: string;
  isCollapsed: boolean;
  isVisible: boolean;
  isFocused: boolean;
  isSearched: boolean;
  parent: number;
  level: number;
  id: number;
  nodeData: any;
}

export class AreaPathNode {
  public title: string;
  public isCollapsed: boolean;
  public isVisible: boolean;
  public isFocused: boolean;
  public isSearched: boolean;
  public level: number;
  public children: number[];
  public parent: number;
  public id: number;
  public nodeData: any;

  constructor(options: NodeAttributes) {
    this.title = options.title;
    this.isCollapsed = options.isCollapsed;
    this.isVisible = options.isVisible;
    this.isFocused = options.isFocused;
    this.isSearched = options.isSearched;
    this.level = options.level;
    this.parent = options.parent;
    this.children = [];
    this.id = options.id;
    this.nodeData = options.nodeData;
  }
}
